import { useEffect, useState } from "react";
import { FaInstagram, FaTiktok, FaSnapchatGhost } from "react-icons/fa";
import { api } from "@/lib/api";

export const CONTACT_PHONE = "07 43 78 03 93";
export const CONTACT_PHONE_HREF = "tel:+33743780393";
export const CONTACT_EMAIL = "fnkfilms.pro@gmail.com";

export const SOCIALS = [
  {
    slug: "instagram",
    name: "Instagram",
    handle: "@fnkstudio69",
    url: "https://www.instagram.com/fnkstudio69",
    Icon: FaInstagram,
    bubbleClass:
      "border-transparent text-white bg-[radial-gradient(circle_at_30%_107%,#fdf497_0%,#fdf497_5%,#fd5949_45%,#d6249f_60%,#285AEB_90%)]",
  },
  {
    slug: "tiktok",
    name: "TikTok",
    handle: "@fnkstudio69",
    url: "https://www.tiktok.com/@fnkstudio69",
    Icon: FaTiktok,
    bubbleClass: "border-white/25 bg-black text-white",
  },
  {
    slug: "snapchat",
    name: "Snapchat",
    handle: "fnkstudio69",
    url: "https://www.snapchat.com/add/fnkstudio69?share_id=YuSgziF8sC0&locale=fr-FR",
    Icon: FaSnapchatGhost,
    bubbleClass: "border-transparent bg-[#FFFC00] text-black",
  },
];

// Liens dynamiques : modifiables dans l'admin (Paramètres) — cache module pour éviter les requêtes multiples
let cachedSocialLinks = null;
let pendingSocialLinks = null;
const fetchSocialLinks = () => {
  if (cachedSocialLinks) return Promise.resolve(cachedSocialLinks);
  if (!pendingSocialLinks) {
    pendingSocialLinks = api
      .get("/settings/public")
      .then((res) => {
        cachedSocialLinks = {
          instagram: res.data.social_instagram || "",
          tiktok: res.data.social_tiktok || "",
          snapchat: res.data.social_snapchat || "",
        };
        return cachedSocialLinks;
      })
      .catch(() => ({}));
  }
  return pendingSocialLinks;
};

export const SocialBubbles = ({ size = "sm", className = "" }) => {
  const [links, setLinks] = useState(cachedSocialLinks || {});
  useEffect(() => {
    fetchSocialLinks().then((l) => setLinks(l || {}));
  }, []);
  const dims = size === "lg" ? "h-11 w-11" : "h-8 w-8";
  const iconDims = size === "lg" ? "h-5 w-5" : "h-4 w-4";
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="social-bubbles">
      {SOCIALS.map(({ slug, name, url, Icon, bubbleClass }) => (
        <a
          key={slug}
          href={links[slug] || url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={name}
          title={name}
          className={`flex ${dims} items-center justify-center rounded-full border transition-opacity duration-150 hover:opacity-80 ${bubbleClass}`}
          data-testid={`social-bubble-${slug}`}
        >
          <Icon className={iconDims} />
        </a>
      ))}
    </div>
  );
};
